// extracted by mini-css-extract-plugin
module.exports = {"illustration":"AuthIllustration_illustration__1HwcV","illustration__block":"AuthIllustration_illustration__block__RRJ8j"};